import styles from './index.module.less';
import { CommonBackContent } from '../Layouts/CommonBackContent';
import { Button, Form, Input } from 'antd';
import { useUserProvider } from '@/context/UserProvider';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useConfigProvider } from '@/context/ConfigProvider';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

const ResetPasswordContent = () => {
  const { onOpenLoginModal, onChangedLoginView } = useUserProvider();
  const [isSendPage, setIsSendPage] = useState(true);
  const router = useRouter();
  const { isBlogWeb } = useConfigProvider();
  const { t } = useTranslation();

  useEffect(() => {
    if (isBlogWeb) {
      router.push('/instagram-tracking-blog');
    }
  }, []);

  const onSendFinish = (values: any) => {
    setIsSendPage(false);
  };

  const onLogin = () => {
    router.push(`/`);
    onChangedLoginView(false);
    onOpenLoginModal(true);
  };

  useEffect(() => {
    setIsSendPage(true);
  }, []);

  if (isBlogWeb) {
    return <></>;
  }
  return (
    <CommonBackContent style={{ minHeight: '100vh' }}>
      <div className={styles.content}>
        {isSendPage ? (
          <Form name="create_password" className={styles.topContainer} onFinish={onSendFinish}>
            <Form.Item>
              <div className={styles.title}>Create a new password</div>
            </Form.Item>
            <Form.Item name="password1" rules={[{ required: true, message: t('pleaseInputYourPassword') }]}>
              <Input
                className={styles.inputContent}
                prefix={
                  <Image
                    src={`/images/user/password-icon.webp`}
                    width={20}
                    height={20}
                    alt={'password'}
                    loading="lazy"
                  />
                }
                type="password"
                placeholder={t('Password')}
              />
            </Form.Item>

            <Form.Item
              name="password2"
              rules={[
                { required: true },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password1') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error(t('theNewPasswordThatYouEnteredDoNotMatch')));
                  },
                }),
              ]}
            >
              <Input
                className={styles.inputContent}
                prefix={
                  <Image
                    src={`/images/user/password-icon.webp`}
                    width={20}
                    height={20}
                    alt={'password'}
                    loading="lazy"
                  />
                }
                type="password"
                placeholder={t('ConfirmPassword')}
              />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" className={styles.loginBtn}>
                {t('Continue')}
              </Button>
            </Form.Item>
          </Form>
        ) : (
          <div className={styles.topContainer}>
            <img src="/images/user/send-email-top-icon.webp" alt="" className={styles.topEmailIcon} />
            <div className={styles.title}>{t('PasswordUpdated')}</div>
            <div className={styles.desc}>{`You can now log in to Replika with your new password`}</div>

            <Button type="primary" onClick={onLogin} className={styles.loginBtn}>
              {t('LogIn')}
            </Button>
          </div>
        )}
      </div>
    </CommonBackContent>
  );
};

export default ResetPasswordContent;
